import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/EDIlogo_lay.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/CoppClarkLogo.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/Econoday_logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/FIILogo.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/FTS Logo (rectangle).png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/Investortools Logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/partners-group.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/Share Data Logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/IPLLogos/SymbolMasterLogo.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/MBISLogo2.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/public/assets/images/Square_SQX.png");
;
import(/* webpackMode: "eager" */ "/var/www/sqxbonds-UI/apps/src/app/LandingPage.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/sqxbonds-UI/apps/src/components/partnersPageComponents/PartnersFooterSection.tsx");
